<template>
  <v-footer class="footer-color">
    <v-row no-gutters justify="center" align="center">
      <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-3 py-0' : 'paddingLR py-1'">
        <div v-if="!$vuetify.breakpoint.smAndDown" class="dotted-line py-3"></div>
        <v-divider v-else class="footer-divider"></v-divider>
      </v-col>

      <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-3 py-0' : 'paddingLR py-0'">
        <v-row no-gutters>
          <p class="main_title">{{ $t(`footer.brandAmbassadors`) }}</p>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToBrandAmbassadorPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/samira_mahi_khan.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Samira Mahi Khan</p>
              <p class="year-text">2024/2025</p>
            </div>
          </v-col>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToBrandAmbassadorPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/apu_biswas.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Apu Biswas</p>
              <p class="year-text">2023/2024</p>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-3 py-1' : 'paddingLR py-1'">
        <div class="dotted-line py-3"></div>
      </v-col>

      <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-3 py-0' : 'paddingLR py-0'">
        <v-row no-gutters>
          <p class="main_title">{{ $t(`footer.sponsorships`) }}</p>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToSponsorshipsPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/vegas_vikings.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Vegas Vikings</p>
              <p class="year-text">2025/2026</p>
            </div>
          </v-col>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToSponsorshipsPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/sudurpaschim_royals.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Sudurpaschim Royals</p>
              <p class="year-text">2024/2025</p>
            </div>
          </v-col>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToSponsorshipsPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/telugu_warriors.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Telugu Warriors</p>
              <p class="year-text">2024/2025</p>
            </div>
          </v-col>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToSponsorshipsPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/colombo_strikers.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Colombo Strikers</p>
              <p class="year-text">2024/2025</p>
            </div>
          </v-col>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToSponsorshipsPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/grand_cayman_jaguars.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Grand Cayman Jaguars</p>
              <p class="year-text">2024/2025</p>
            </div>
          </v-col>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToSponsorshipsPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/montreal_tigers.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Montreal Tigers</p>
              <p class="year-text">2023/2024</p>
            </div>
          </v-col>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToSponsorshipsPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/dambulla_aurea.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Dambulla Aura</p>
              <p class="year-text">2023/2024</p>
            </div>
          </v-col>
          <v-col cols="6" lg="2" md="4" class="d-flex py-1 sponsor-cursor" @click="redirectToSponsorshipsPage">
            <img loading="lazy" class="" width="40" height="40" src="/static/image/footer/northern_warriors.png" alt />
            <div class="sponsor-border">
              <p class="sponsorship-text">Northern Warriors</p>
              <p class="year-text">2023/2024</p>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-3 py-1' : 'paddingLR py-1'">
        <div class="dotted-line py-3"></div>
      </v-col>

      <v-row v-if="$vuetify.breakpoint.smAndDown" no-gutters justify="space-between" :class="$vuetify.breakpoint.xsOnly ? 'px-3' : 'paddingLR py-1'">
        <v-col cols="12" class="py-1">
          <v-row no-gutters>
            <label class="subtitle-1 footer-link-label">
              <p class="main_title">{{ $t(`label.paymentMethod`) }}</p>
            </label>
          </v-row>
          <v-row no-gutters class="d-flex align-center">
            <v-row no-gutters class="d-flex align-center" v-if="currency.toLowerCase() === 'bdt'">
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bkash_colour.svg" alt="bkash9" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_nagad_colour.svg" alt="nagad" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_rocket_colour.svg" alt="rocket" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_upay_colour.svg" alt="upay" />
              </a>
            </v-row>
            <v-row no-gutters class="d-flex align-center" v-else-if="currency.toLowerCase() === 'inr'">
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_paytm_colour.svg" alt="bkash9" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_phonepe_colour.svg" alt="nagad" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_UPI_colour.svg" alt="rocket" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bankdeposit_colour.svg" alt="upay" />
              </a>
            </v-row>
            <v-row no-gutters class="d-flex align-center" v-else-if="currency.toLowerCase() === 'npr'">
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_connectIPS_colour.svg" alt="bkash9" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_khaltiwallet_colour.svg" alt="nagad" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_esewa_colour.svg" alt="rocket" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bankdeposit2_colour.svg" alt="upay" />
              </a>
            </v-row>
          </v-row>
        </v-col>
        <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-0 py-1' : 'paddingLR py-1'">
          <div class="dotted-line py-3"></div>
        </v-col>
        <v-col cols="12" class="py-1">
          <v-row no-gutters>
            <p class="main_title">{{ $t(`label.responsibleGaming`) }}</p>
          </v-row>
          <v-row no-gutters class="">
            <img loading="lazy" class="footer-icon" src="/static/svg/btm-18+.svg" alt />
            <img loading="lazy" class="footer-icon" src="/static/svg/btm-gamcare.svg" alt />
          </v-row>
        </v-col>
        <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-0 py-1' : 'paddingLR py-1'">
          <div class="dotted-line py-3"></div>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-row no-gutters>
            <label class="subtitle-1 footer-link-label">
              <p class="main_title">{{ $t(`footer.followUs`) }}</p>
            </label>
          </v-row>
          <v-row no-gutters>
            <a :href="this.fblink" target="_blank">
              <img loading="lazy" class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-fb.svg" alt />
            </a>
            <a :href="this.ytLink" target="_blank" @mouseenter="hoverYT = true" @mouseleave="hoverYT = false">
              <img loading="lazy" class="footer-icon" :src="hoverYT ? '/static/svg/hover_btm-yt.svg' : '/static/svg/btm-yt.svg'" alt />
            </a>
            <a :href="this.instaLink" target="_blank" v-if="this.currency == currenciesList.BDT">
              <img loading="lazy" class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-ig.svg" alt />
            </a>
            <a :href="this.twtLink" target="_blank" @mouseenter="hoverX = true" @mouseleave="hoverX = false" v-if="this.currency == currenciesList.BDT">
              <img loading="lazy" class="footer-icon" :src="hoverX ? '/static/svg/hover_btm-twitter.svg' : '/static/svg/btm-twitter.svg'" alt />
            </a>
            <a :href="this.tlgLink" target="_blank">
              <img loading="lazy" class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-tlg.svg" alt />
            </a>
          </v-row>
        </v-col>
        <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-0 py-1' : 'paddingLR py-1'">
          <div class="dotted-line py-3"></div>
        </v-col>
        <v-col cols="12" class="py-0 pb-2">
          <v-row no-gutters class="">
            <a :href="this.casinolink" target="_blank">
              <img loading="lazy" class="mr-3 mt-0" width="180" src="/static/image/footer/babu88-official.png" alt />
            </a>
          </v-row>
          <v-row no-gutters class="align main_title">
            {{ $t(`footer.bangladeshNo1`) }}
          </v-row>
          <v-row no-gutters class="align white--text copy-right-title">
            {{ footerCopyRight }}
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="!$vuetify.breakpoint.smAndDown" no-gutters justify="space-between" :class="$vuetify.breakpoint.xsOnly ? 'px-1 pl-4' : 'paddingLR py-0'">
        <v-col cols="6" class="py-1">
          <v-row no-gutters>
            <label class="subtitle-1 footer-link-label">
              <p class="main_title">{{ $t(`label.paymentMethod`) }}</p>
            </label>
          </v-row>
          <v-row no-gutters v-if="$vuetify.breakpoint.mdAndUp" class="d-flex align-center">
            <!--              <img class="mr-3" width="162" height="32" src="/static/image/footer/475047.png" alt />-->
            <v-row no-gutters class="d-flex align-center" v-if="currency.toLowerCase() === 'bdt'">
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bkash_colour.svg" alt="bkash9" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_nagad_colour.svg" alt="nagad" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-1 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_rocket_colour.svg" alt="rocket" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_upay_colour.svg" alt="upay" />
              </a>
            </v-row>
            <v-row no-gutters class="d-flex align-center" v-else-if="currency.toLowerCase() === 'inr'">
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_paytm_colour.svg" alt="bkash9" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_phonepe_colour.svg" alt="nagad" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-1 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_UPI_colour.svg" alt="rocket" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bankdeposit_colour.svg" alt="upay" />
              </a>
            </v-row>
            <v-row no-gutters class="d-flex align-center" v-else-if="currency.toLowerCase() === 'npr'">
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_connectIPS_colour.svg" alt="bkash9" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_khaltiwallet_colour.svg" alt="nagad" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-1 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_esewa_colour.svg" alt="rocket" />
              </a>
              <a>
                <img loading="lazy" class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bankdeposit2_colour.svg" alt="upay" />
              </a>
            </v-row>
          </v-row>
        </v-col>
        <v-col cols="6" class="py-1">
          <v-row no-gutters>
            <p class="main_title">{{ $t(`label.responsibleGaming`) }}</p>
          </v-row>
          <v-row no-gutters class="">
            <img loading="lazy" class="footer-icon" src="/static/svg/btm-18+.svg" alt />
            <img loading="lazy" class="footer-icon" src="/static/svg/btm-gamcare.svg" alt />
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" class="paddingLR py-5" v-if="$vuetify.breakpoint.mdAndUp">
        <div v-if="!$vuetify.breakpoint.smAndDown" class="dotted-line py-4"></div>
        <v-row v-if="$vuetify.breakpoint.mdAndUp" no-gutters justify="space-between">
          <v-col cols="6" class="py-0">
            <v-row no-gutters class="">
              <a :href="this.casinolink" target="_blank">
                <img loading="lazy" class="mr-3 mt-0" width="180" src="/static/image/footer/babu88-official.png" alt />
              </a>
            </v-row>
            <v-row no-gutters class="align main_title">
              {{ $t(`footer.bangladeshNo1`) }}
            </v-row>
            <v-row no-gutters class="align white--text copy-right-title">
              {{ footerCopyRight }}
            </v-row>
          </v-col>
          <v-col cols="6" class="py-0">
            <v-row no-gutters>
              <label class="subtitle-1 footer-link-label">
                <p class="main_title">{{ $t(`footer.followUs`) }}</p>
              </label>
            </v-row>
            <v-row no-gutters>
              <a :href="this.fblink" target="_blank" v-if="this.currency == currenciesList.BDT || this.currency == currenciesList.INR">
                <img loading="lazy" class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-fb.svg" alt />
              </a>
              <a :href="this.ytLink" target="_blank" @mouseenter="hoverYT = true" @mouseleave="hoverYT = false">
                <img loading="lazy" class="footer-icon" :src="hoverYT ? '/static/svg/hover_btm-yt.svg' : '/static/svg/btm-yt.svg'" alt />
              </a>
              <a :href="this.instaLink" target="_blank" v-if="this.currency == currenciesList.BDT">
                <img loading="lazy" class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-ig.svg" alt />
              </a>
              <a :href="this.twtLink" target="_blank" @mouseenter="hoverX = true" @mouseleave="hoverX = false" v-if="this.currency == currenciesList.BDT">
                <img loading="lazy" class="footer-icon" :src="hoverX ? '/static/svg/hover_btm-twitter.svg' : '/static/svg/btm-twitter.svg'" alt />
              </a>
              <a :href="this.tlgLink" target="_blank">
                <img loading="lazy" class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-tlg.svg" alt />
              </a>
            </v-row>
          </v-col>
        </v-row>
        <!--        <v-divider class="footer-divider"></v-divider>-->
        <v-row no-gutters v-show="!isViewableAll && $vuetify.breakpoint.smAndDown">
          <v-col cols="12" :lg="4">
            <!-- <v-row>
                            <v-col cols="12" class="text-decoration-underline pt-0">
                                <v-btn text @click="isViewableAll = true" class="font-weight-bold">
                                    Understand more
                                </v-btn>
                            </v-col>
                        </v-row> -->
          </v-col>
        </v-row>
      </v-col>

      <v-row no-gutters v-show="$vuetify.breakpoint.mdAndUp || isViewableAll" class="py-6 paddingLR second_footer">
        <v-col cols="12">
          <h3 class="main_title pb-2">
            {{ $t(`footer.trustedPremiumOnlineCasinoTitle`) }}
          </h3>
          <p class="seo_text">{{ $t(`footer.trustedPremiumOnlineCasinoDesc_1`) }}</p>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.gameAvailable`) }}
              </h3>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.slotGames`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.slotGamesDes`) }}
              </p>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.sportsBetting`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.sportsBettingDes`) }}
                <!--                <br />-->
                <!--                {{ $t(`footer.liveCasinoGamesOnlineCasinoDesc_2`) }}-->
                <!--                <br />-->
                <!--                {{ $t(`footer.liveCasinoGamesOnlineCasinoDesc_3`) }}-->
              </p>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.liveCasino`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.liveCasinoDes`) }}
                <!--                <br />-->
                <!--                {{ $t(`footer.sportsBettingDesc_2`) }}-->
                <!--                <br />-->
                <!--                {{ $t(`footer.sportsBettingDesc_3`) }}-->
                <!--                <br />-->
                <!--                {{ $t(`footer.sportsBettingDesc_4`) }}-->
                <!--                <br />-->
                <!--                {{ $t(`footer.sportsBettingDesc_5`) }}-->
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.paymentOptions`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.paymentOptionsDes`) }}
              </p>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.license`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.licenseDes`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.tnc`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.tncDes`) }}
              </p>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.24/7support`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.24/7supportDes`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <label @click="showMore = !showMore" v-if="!showMore" class="readMore">{{ $t(`footer.readMore`) }}</label>
        <label @click="showMore = !showMore" v-if="showMore" class="readMore">{{ $t(`footer.readLess`) }}</label>
      </v-row>
    </v-row>
  </v-footer>
</template>

<script>
import NavOnePay from '@/assets/svg/onePay.svg'
import { ROUTE_NAME } from '@/constants/route.constants'
import format from 'string-format'
import { locale, uiHelper } from '@/util'
import { SHARED, CACHE_KEY, Currencies } from '@/constants/constants'
import { SHARED_LOADING } from '@/store/shared.module'
import _ from 'lodash'

export default {
  name: 'appFooter',
  props: {},
  components: {
    NavOnePay
  },
  data: () => ({
    showMore: false,
    hoverX: false,
    hoverYT: false,
    currenciesList: Currencies,
    currency: uiHelper.getCurrency(),
    casinolink: uiHelper.getcasinoLink(),
    fblink: uiHelper.getFBLink(),
    instaLink: uiHelper.getInstaLink(),
    twtLink: uiHelper.getTwtLink(),
    ytLink: uiHelper.getYTLink(),
    tlgLink: uiHelper.getTlgLink(),
    isViewableAll: false,
    footerProvider: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_LIST_TYPE_NAME}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    supportedLanguage: SHARED.SUPPORTED_LANGUAGES,
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    footerLink: [
      // {
      //   link: '/customer-service',
      //   text: locale.getMessage(`label.customerService`)
      // },
      {
        routeName: ROUTE_NAME.TNC,
        text_key: 'termsAndConditions'
      },
      {
        routeName: ROUTE_NAME.ABOUT_US,
        text_key: 'aboutUs'
      },
      {
        routeName: ROUTE_NAME.FAQ,
        text_key: 'faq'
      },
      {
        routeName: ROUTE_NAME.CONTACT_US,
        text_key: 'contactUs'
      }
    ],
    footerCopyRight: format(locale.getMessage(`message.copyRight`), new Date().getFullYear())
  }),
  computed: {
    ProviderTypes() {
      return this.$store.state.game.ProviderTypes
    }
  },
  watch: {
    ProviderTypes() {
      this.footerProvider = uiHelper.getLocalStorage(`${CACHE_KEY.GAME_LIST_TYPE_NAME}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`)
      return this.$store.state.game.ProviderTypes
    }
  },
  methods: {
    changeLanguage(language) {
      this.$store.dispatch(`${SHARED_LOADING}`)
      locale.setCurrentLanguage(language)
      uiHelper.removeCookie('language')
      uiHelper.setCookie('language', language)
      window.location.reload()
    },
    goToFirstCagayan() {
      window.open('https://www.firstcagayan.com/zh-hant#2', '_blank')
    },
    goToPagcor() {
      window.open('https://pagcor.ph/index.php', '_blank')
    },
    redirectToSponsorshipsPage() {
      this.$router.push({ name: ROUTE_NAME.SPONSORSHIPS })
    },
    redirectToBrandAmbassadorPage() {
      this.$router.push({ name: ROUTE_NAME.BRAND_AMBASSADORS })
    },
  }
}
</script>

<style lang="scss">
.grayscale-on-hover:hover {
  filter: grayscale(0%);
}
.grayscale-on-hover {
  filter: grayscale(100%);
}
.readMore {
  color: #0080f6;
  text-decoration: underline;
}
.paddingLR {
  padding: 0 12% !important;
}
.second_footer {
  background-color: #000;
  color: #fff;
}
.dotted-line {
  border-top: 1px dotted #fff; /* Adjust the color and thickness as needed */
  margin-top: 10px; /* Adjust the margin as needed */
}
.footer-divider {
  color: #3a3a3a;
}
.footer-icon {
  float: center;
  display: block;
  width: 50px;
  height: 50px;
  margin: 5px 12px 0px 0px;
}
.navPayIcon {
  width: 120px;
  height: 50px;
  margin-top: -15px;
  fill: #0f80aa;
}

.payNowIcon {
  width: 144px;
  height: 28px;
}

.main_title {
  color: #FFCE01;
  font-size: 14px;
}

.copy-right-title {
  font-size: 14px;
}

.seo_text {
  font-size: 14px;
  color: #fff;
}

.sponsor-cursor {
  cursor: pointer;

  @media (max-width: 360px) {
      flex: 0 0 100%;
      max-width: 100%;
  }
}

.sponsor-border {
  margin: 0 8px;
  align-content: center;

  .sponsorship-text {
    display: block !important;
    font-size: 14px;
    margin-bottom: -4px;
    color: #fff;
  }

  .year-text {
    display: block;
    font-size: 10px;
    margin-bottom: 0;
    color: #fff;
  }
}

.v-footer {
  min-height: 200px;
  background-color: #ebebeb;
  padding: 25px 0 0px;

  .footer-box-title {
    font-size: 18px;
    display: block;
    padding: 10px 0px;
  }

  .footer-link-label {
    color: #3a3a3a;
    letter-spacing: 0;
    cursor: pointer;

    &:hover {
      color: white;
    }
  }

  .footer-link-divider {
    border-color: #3a3a3a;
  }
}

.footer-row {
  padding-left: 65px;
  padding-right: 65px;

  &.col {
    padding: 0px 8px;
  }
}

.footer-image {
  margin-right: 15px;
  margin-bottom: 10px;
  height: 30px;

  &.language,
  &.license {
    cursor: pointer;
  }
}

.footer-color {
  background-color: #333333 !important;
}

@media (max-width: 1650px) {
}

@media (max-width: 1500px) {
}

@media (max-width: 1350px) {
  .footer-box-title,
  .footer-link-label {
    font-size: 14px;
  }
}

@media (max-width: 1263px) {
  .footer-vendor-box-col {
    min-width: 90%;
    max-width: 90%;

    .footer-vendor-box {
      max-width: 100%;
    }
  }

  .footer-image {
    height: 25px;
  }
}

@media (max-width: 1024px) {
}

@media (max-width: 959px) {
}

@media (max-width: 599px) {
  .footer-icon {
    float: center;
    display: block;
    width: 30px;
    height: 30px;
    margin: 5px 12px 0px 0px;
  }
  .footer-box-title,
  .footer-link-label {
    font-size: 16px;
  }

  .footer-vendor-box-col {
    min-width: 90%;
    max-width: 90%;
    text-align: center;
  }
  .footer-transaction-method-box-col {
    min-width: 90%;
    max-width: 90%;
    text-align: center;
  }
  .footer-license-box-col {
    min-width: 90%;
    max-width: 90%;
    text-align: center;
  }
  .footer-language-box-col {
    min-width: 90%;
    max-width: 90%;
    text-align: center;
  }
}

@media (max-width: 425px) {
}
@media (min-width: 900px) {
  .footer-color {
    background-color: #333333 !important;
  }
}
</style>
